import React from 'react';
import './About.css';
import SEO from './SEO';

const About = () => {
  return (
    <div className="about-container">
      <SEO
        title="About Tuomas Kivioja & Internet Made Media FZCO - Expert Expat Relocation Services"
        description="Learn about Tuomas Kivioja, founder of Internet Made Media FZCO, and our expert expat relocation services. Specializing in UAE company setup, Dubai Golden Visa, Mexico residency, citizenship by investment, and international tax optimization."
        keywords="Internet Made Media FZCO, Tuomas Kivioja, expat relocation specialist, UAE company setup expert, Dubai relocation consultant, international tax advisor, citizenship by investment consultant, Mexico residency expert"
        canonical="https://tuomaskivioja.com/about"
        ogImage="https://tuomaskivioja.com/tuomas.jpg"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "About Internet Made Media FZCO",
          "description": "About Tuomas Kivioja and Internet Made Media FZCO expat relocation services",
          "url": "https://tuomaskivioja.com/about",
          "mainEntity": {
            "@type": "Person",
            "name": "Tuomas Kivioja",
            "jobTitle": "Founder & International Relocation Specialist",
            "worksFor": {
              "@type": "Organization",
              "name": "Internet Made Media FZCO"
            },
            "image": "https://tuomaskivioja.com/tuomas.jpg"
          }
        }}
      />

      {/* Founder Section */}
      <section className="founder-section">
        <div className="founder-content">
          <div className="founder-image">
            <img src="/tuomas.jpg" alt="Tuomas Kivioja" />
          </div>
          <div className="founder-text">
            <h2>Who Am I?</h2>
            <h3>Tuomas Kivioja</h3>
            <p className="founder-title">Founder & International Relocation Specialist</p>
            <p>
              Hi! I'm Tuomas, and I've spent years navigating the complex world of international 
              relocation, tax residency, and global business setup.
            </p>
            <p>
              Whether you're looking to reduce your tax burden, obtain a second residency or citizenship, 
              set up a business in a new jurisdiction, or simply explore your options for living abroad, 
              I'm here to help you navigate every step of the process.
            </p>
          </div>
        </div>
      </section>

      {/* What We Do Section */}
      <section className="services-section">
        <h2>What We Do</h2>
        <p className="section-intro">
          We specialize in helping individuals and businesses achieve location independence 
          and international growth through:
        </p>
        <div className="services-grid">
          <div className="service-card">
            <div className="service-icon">🇦🇪</div>
            <h3>UAE Company Setup & Relocation</h3>
            <p>
              Complete UAE company formation with residence visa, 0% tax residence setup, 
              and Golden Visa pathways through real estate investment.
            </p>
            <div className="service-highlight">Most Popular</div>
          </div>
          
          <div className="service-card">
            <div className="service-icon">🇲🇽</div>
            <h3>Mexico Residency Program</h3>
            <p>
              Professional guidance through Mexico's Economic Solvency Residency Program 
              with pathway to citizenship in as little as 2 years.
            </p>
          </div>
          
          <div className="service-card">
            <div className="service-icon">🌎</div>
            <h3>Citizenship by Investment</h3>
            <p>
              Access to premium citizenship programs offering visa-free travel to 150+ countries 
              and generational wealth planning opportunities.
            </p>
          </div>
          
          <div className="service-card">
            <div className="service-icon">🇸🇬</div>
            <h3>Singapore & Hong Kong Setup</h3>
            <p>
              Company incorporation and relocation support in Asia's premier business hubs 
              with employment pass assistance.
            </p>
          </div>
          
          <div className="service-card">
            <div className="service-icon">🇺🇸</div>
            <h3>US LLC Formation</h3>
            <p>
              0% tax US LLC setup for non-residents with full banking and payment processing 
              infrastructure in just 48 hours.
            </p>
          </div>
          
          <div className="service-card">
            <div className="service-icon">💼</div>
            <h3>Personal Consultation</h3>
            <p>
              One-on-one strategy sessions to help you choose the optimal relocation and 
              tax optimization strategy for your unique situation.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
